<template>
  <EntrustFlow flow-model="RoutineEntrustFlow" />
</template>

<script>
import EntrustFlow from './EntrustFlow.vue'

export default {
  name: 'RoutineEntrustFlow',
  components: { EntrustFlow }
}
</script>
